module.exports = __webpack_public_path__ + "static/PrimitiveSeven-82ef642b81d35a135ac958bfb9ab20e2.png";